/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Awaiting_WaybillInputs */

const vi_carrier_awaiting_waybill = /** @type {(inputs: Carrier_Awaiting_WaybillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang chờ hãng cấp mã vận đơn`)
};

/**

* @param {Carrier_Awaiting_WaybillInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_awaiting_waybill = /** @type {((inputs?: Carrier_Awaiting_WaybillInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Awaiting_WaybillInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_awaiting_waybill(inputs)
});